import React, { useEffect } from 'react';
import { Grid, Card, Typography, Tabs, Tab } from '@mui/material';
import { GiftStatusEnum } from '../utils';
const GiftTabs = ({ giftListData, selectedStatus, setSelectedStatus }) => {
  
  const uniqueStatuses = giftListData 
    ? [...new Set(giftListData.flatMap((gift) => gift.data.map((item) => item.status)))] 
    : [];
  useEffect(() => {
    if (uniqueStatuses.length > 0 && !selectedStatus) {
      setSelectedStatus(uniqueStatuses[0]);
    }
  }, [uniqueStatuses, selectedStatus, setSelectedStatus]);
  
  const handleChangeforStatus = (event, newValue) => {
    setSelectedStatus(newValue);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={12}>
        <Card
          sx={{
            borderRadius: '12px',
            boxShadow:
              '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
            marginBottom: '20px',
            p: 2,
          }}
        >
          <Typography sx={{ color: '#636363', pb: 2, fontWeight: 'bold' }}>
            Select From Below
          </Typography>
          <Tabs
            value={selectedStatus}
            variant="scrollable"
            allowScrollButtonsMobile
            scrollButtons="auto"
            onChange={handleChangeforStatus}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            {uniqueStatuses.map((status) => {
              const statusEnum = Object.values(GiftStatusEnum).find(
                (item) => item.status === status
              );
              return (
                <Tab
                  key={status}
                  label={statusEnum?.label}
                  value={status}
                  icon={statusEnum?.icon}
                  sx={{
                    flex: { sm: 1 },
                    width: { xs: '33%', sm: 'auto' },
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                />
              );
            })}
          </Tabs>
        </Card>
      </Grid>
    </Grid>
  );
};

export default GiftTabs;
